import { useCallback } from "react";

import DownloadIcon from "@mui/icons-material/Download";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import saveAs from "file-saver";

type RecordingProps = {
  url: string;
  audioRef: React.MutableRefObject<HTMLAudioElement | null>;
};

export default function Recording({ url, audioRef }: RecordingProps) {
  const handleDownload = useCallback(() => {
    saveAs(url);
  }, [url]);

  return (
    <Stack width="100%" sx={{ boxSizing: "border-box" }}>
      <Typography component="div" sx={{ color: "grey", ml: 3, mb: 1.5 }}>
        Recording:
      </Typography>
      <Stack pl={3} pr={1} direction="row" alignItems="center" spacing={1}>
        <audio ref={audioRef} controls>
          <source src={url} type="audio/mpeg" />
          Your browser does not support the audio element.
        </audio>
        <IconButton size="small" onClick={handleDownload}>
          <DownloadIcon />
        </IconButton>
      </Stack>
    </Stack>
  );
}
